import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 280px;

  @media (max-width: 576px) {
    max-width: 100%;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.communityList.background};
  height: 48px;
  padding: 7px 10px;
  border-radius: 24px;
  user-select: none;
  border: 2px solid;
  border-color: ${({ theme }) => theme.communityList.borderColor};
`;

export const SearchInput = styled.input`
  font-size: 16px;
  border: none;
  background-color: transparent;
  outline: none;
  color: ${({ theme }) => theme.communityList.color};
  flex: 1;
`;

export const SearchIcon = styled.div`
  :after {
    content: '\f002';
    font-family: FontAwesome;
    color: ${({ theme }) => theme.communityList.color};
    margin-left: 5px;
  }
`;

export const ClearIcon = styled.div`
  :after {
    content: '\f00d';
    font-family: FontAwesome;
    color: ${({ theme }) => theme.communityList.color};
    cursor: pointer;
  }
`;
